import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import AppProvider from "providers/AppProvider";
import AuthProvider  from "contexts/AuthContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { router } from "routes";
import "helpers/initFA";
import { PermissionsProvider } from "components/access-control/rbac/PermissionContext";
import { FiltersProvider } from "providers/FiltersProvider";
import DashboardProvider from "providers/DashboardProvider";

const container = document.getElementById("main");
const root = createRoot(container);

const clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientID}>
      <AppProvider>
          <AuthProvider>
            <PermissionsProvider>
              <FiltersProvider>
                <DashboardProvider>
                  <RouterProvider router={router} />
                </DashboardProvider>
              </FiltersProvider>
            </PermissionsProvider>
          </AuthProvider>
      </AppProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
